export default __webpack_public_path__ + "static/media/menu.3c24ae10.svg";